import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, rem, SettingsItem, SettingsSection } from 'design-system';
import useColors from 'hooks/useColors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { IconNordVPN } from 'design-system/icons/IconNordVPN';
import Squircle from 'design-system/Squircle';
import Text from 'design-system/Text';
import Card from 'features/feed/components/Card';
import { benefits } from 'features/premium/benefits';
import Status from 'design-system/Status';
import { useAppSelector } from 'store/hooks';
import { selectVpnStatus } from 'features/NordVpn/selectors';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import { NordVPNStatusEnum } from './types';
import { isWeb } from '../../constants';
export const NordVPNCard = ({ isNordVPNAvailable, }) => {
    const { name, text } = benefits.nordVPN;
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const vpnStatus = useAppSelector(selectVpnStatus);
    const handlePress = useCallback(() => {
        if (isWeb) {
            UnavailableOnWebModal.show('emma://nordvpn', 'NordVPN');
        }
        else {
            navigation.navigate('ManageNordVpn');
        }
    }, []);
    if (vpnStatus === NordVPNStatusEnum.ACTIVE && isNordVPNAvailable) {
        return (<SettingsSection noMarginTop>
        <SettingsItem onPress={handlePress} topDescription={<Status active activeText={'Active'} inactiveText="Inactive"/>} title={name} titleFirst description={text} icon={<IconNordVPN />}></SettingsItem>
      </SettingsSection>);
    }
    return (<Card style={styles.cardContainer} withPadding>
      <Squircle color={colors.background.dark}>
        <IconNordVPN />
      </Squircle>
      <View style={styles.textContainer}>
        <Text Text-16>Activate your account</Text>
        <Text TextThin-14 Secondary>
          {text}
        </Text>
      </View>
      <Button brandLight small square title={`Set up ${name}`} onPress={handlePress}/>
    </Card>);
};
const styles = StyleSheet.create({
    textContainer: {
        gap: rem(4),
        flex: 1,
    },
    cardContainer: {
        gap: rem(16),
        marginHorizontal: rem(16),
    },
});
